/* eslint-disable camelcase */
import React from 'react';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import classNames from 'classnames';
import { useTheme } from '@components/theme';
import breakpoints from '@constants/breakpoints';
import PrismicImage from '@components/shared/images/atoms/Image/PrismicImage';
import { useMaxBreakpoint } from '@hooks/useMediaQuery/useMediaQuery';
import { IHeroBanner } from '../../model/prismic';
import styles from './HeroBanner.module.scss';

const HeroBanner = ({
  title,
  subtitle,
  ctaLabel,
  ctaUrl,
  image
}: IHeroBanner) => {
  const theme = useTheme();
  const isMobile = useMaxBreakpoint('desktop');

  return (
    <section
      className={classNames(
        styles.HeroBanner,
        theme.styles.Section
      )}
    >
      <div className={styles.HeroWrapper}>
        <PrismicImage
          image={image}
          lazy={false}
          breakpoints={{
            mobile: breakpoints.desktop
          }}
        />
        <div className={styles.HeroOverlay} />
      </div>
      <div className={styles.Content}>
        <h1 className={classNames(
          theme.styles.Header,
          theme.styles.Core2,
          styles.HeroTitle,
          { [styles.NoSubtitle]: !subtitle }
        )}
        >
          {title}
        </h1>
        {subtitle && (
          <h2 className={classNames(theme.styles.Header, theme.styles.Core2, styles.Subtitle)}>
            {subtitle}
          </h2>
        )}
        <a
          role="button"
          href={ctaUrl}
          className={classNames(
            theme.styles.Button,
            { [theme.styles.Primary]: isMobile },
            { [theme.styles.Conflicting]: !isMobile },
          )}
          type="button"
          onClick={() => {
            analyticsTrack(
              `cta_clicked`, {
                title: `Shop Landing Page | Hero Banner | ${title}`,
                ctaLabel
              }
            );
          }}
        >
          {ctaLabel}
        </a>
      </div>
    </section>
  );
};

export default HeroBanner;
